import axios from 'axios';
import { endpoints } from 'utils/global-constants';

/**
 * Get featured events with params
 * @param {object} requestParams
 * @returns
 */
export const getFeaturedEventsForContent = async ({ itemId, pageNum, itemsPerPage }) => {
  const requestParams = `filter=${itemId}&pageNumEvent=${pageNum}&itemsPerPage=${itemsPerPage}`;

  try {
    const response = await axios.get(`${endpoints.getFeaturedEventsForContent}?${requestParams}`);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Get featured events
 * @returns
 */
export const getFeaturedEvents = async () => {
  try {
    const response = await axios.get(endpoints.getFeaturedEvents);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};
